<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>

      <v-card class="box no-display">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Monthly Paysheet Summary Report</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <p><b>Salary Month</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sal_month" :items="sal_month_list"
              item-text="name" item-value="id" label="Salary Month" outlined />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Employee Type</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee_type" :items="employee_type_list"
              item-text="name" item-value="id" label="Employee Type" outlined />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Designation</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="designation" :items="designation_list"
              item-text="name" item-value="id" label="Designation" outlined />
          </v-col>
          <v-col cols="12" sm="3" md="3">
            <p><b>Employee</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="employee" :items="employee_list"
              item-text="name" item-value="id" label="Employee" outlined />
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col cols="12" sm="3" md="3">
            <v-btn class="button" v-if="sal_month" @click="
                fetchSalaryRegister();
                loader = true;
              ">Fetch Report</v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="box" v-if="emp_salary_reg_detail != '' && loader">
        <v-toolbar flat dense class="toolbar no-display">
          <v-toolbar-title>Employee Monthly Salary Register Details</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- excel btn code -->
        <v-row dense class="no-display">
          <v-col cols="12" sm="6" md="3">
            <v-btn class="ma-2" rounded color="success" outlined @click="
                fnExcelReport('my-table-id', 'MonthlyPaySheetSummaryReport')
              "><v-icon color="success">mdi-export</v-icon>Export</v-btn>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <!-- <v-btn class="button no-display" @click="exportToPDF"
                >Export to PDF</v-btn
              > -->
            <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()">
              <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <div id="my-table-id">
          <v-simple-table id="my-table-id1" fixed-header dense class="table-data"
            v-if="emp_salary_reg_detail.length > 0">
            <thead>
              <tr class="toolbar">
                <td align="center">Sr. No.</td>
                <td align="center">Employee</td>
                <td align="center">Employee Type</td>
                <td align="center">Employee Section</td>
                <td align="center">Employee Designation</td>
                <td align="center">Bank Account No.</td>
                <td align="center">PF Account No.</td>
                <td align="center">No. Of Working Days</td>
                <td align="center" v-for="(header, index) in comp_header" :key="index">
                  {{ header }}
                </td>
                <td align="center">Gross Salary</td>
                <td align="center">Gross Deduction</td>
                <td align="center">Net Salary</td>
                <td align="center">Sign</td>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(s, index) in emp_salary_reg_detail" :key="index">
                <td align="">{{ index + 1 }}</td>
                <td align="">{{ s.emp_name }}</td>
                <td align="">{{ s.emp_type }}</td>
                <td align="">{{ s.emp_section }}</td>
                <td align="">{{ s.emp_designation }}</td>
                <td align="">{{ s.emp_bank_ac_no }}</td>
                <td align="">{{ s.emp_pf_no }}</td>
                <td>
                  <center>{{ s.emp_working_days }}</center>
                </td>

                <td v-for="comp in s.comp_value" :key="comp.emp_sd_id">
                  <center>
                    {{ comp.s_value }}
                  </center>
                </td>
                <td>
                  <center>{{ s.gross_salary }}</center>
                </td>
                <td>
                  <center>{{ s.gross_deductions }}</center>
                </td>
                <td>
                  <center>{{ s.net_salary }}</center>
                </td>
                <td>
                  <center></center>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card>
      <!-- <v-col cols="12" sm="12" md="12"> -->

      <!-- </v-col> -->
    </v-container>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    // title: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    description: "",
    sal_month_list: [],
    employee_type_list: [],
    employee_list: [],
    designation_list: [],
    sal_month: null,
    sal_month_copy: null,
    inst_list: null,
    employee_type: null,
    employee: null,
    designation: null,
    comp_header: [],
    emp_salary_reg_detail: [],
    emp_sal_reg_id: null,
    comp_rule_edit: null,
    component_rule_edit: null,
    overlay: false,
  }),
  methods: {
    // print() {
    //   this.$store.state.drawer = false;
    //   let that = this;
    //   window.onafterprint = function () {
    //     that.$store.state.drawer = true;
    //   };
    //   setTimeout(function () {
    //     window.print();
    //   }, 100);
    // },
    print() {
  this.$store.state.drawer = false;
  let that = this;
  window.onafterprint = function () {
    that.$store.state.drawer = true;
  };
  setTimeout(() => {
    const mediaQueryList = window.matchMedia('print');
    mediaQueryList.addListener(function (mql) {
      if (!mql.matches) document.body.classList.remove('landscape');
    });
    document.body.classList.add('landscape');
    window.print();
  }, 150);
},
    exportToPDF() {
      html2pdf(document.getElementById("my-table-id1"), {
        // margin: 1,
        filename: "i-was-html.pdf",
        // html2canvas: { scale: 1, useCORS: true },

        jsPDF: {
          unit: "in",
          format: "a4",

          // width: 20,
          // height: 17,
          page_size: "16 17",
          orientation: "portrait",
        },
      });
    },

    // async exportToPDF() {
    //   console.log("hi");
    //   await html2pdf(this.$refs.document, {
    //     enableLinks: false,
    //     margin: 0,
    //     filename: "MonthlyReport.pdf",
    //     image: { type: "jpeg", quality: 0.98 },
    //     html2canvas: { scale: 1, useCORS: true },
    //     jsPDF: { unit: "in", format: "a4", orientation: "landscape" },
    //   });
    //   console.log("hi1");
    // },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
       const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    editItem(emp_sal_reg_id) {
      //  alert(emp_sal_reg_id)
      this.emp_sal_reg_id = emp_sal_reg_id;
      this.edit_flag = "yes";
      this.dialog_edit = true;
    },
    fetchSalaryRegister() {
      (this.emp_salary_reg_detail = []), (this.comp_header = []);
      const data = {
        sal_month: this.sal_month,
        employee_type: this.employee_type,
        designation: this.designation,
        employee: this.employee,
      };
      this.overlay = true;
      axios
        .post("/Payroll/fetchSalaryRegister", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.emp_salary_reg_detail = res.data.emp_salary_reg_detail;
            this.comp_header = res.data.comp_header;
            this.overlay = false;
            // this.sal_month=''
          } else if (res.data.flag == "No") {
            this.showSnackbar("#b71c1c", res.data.snackbar);
            this.overlay = false;
            return;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.overlay = false;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something Went Wrong");
          this.loader = false;
        })
        .finally(() => {
          this.show_copy_dialog = true;
        });
    },
    onLoad() {
      axios
        .post("/Payroll/getInitialData")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.sal_month_list = res.data.sal_month_list;
            this.employee_type_list = res.data.employee_type_list;
            this.employee_list = res.data.employee_list;
            this.designation_list = res.data.designation_list;
            this.inst_list = res.data.inst_list;
            this.inst_data = res.data.inst_data;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
/* .v-text-field{
      width: 80px;
} */
thead {
  font-weight: bold !important;
}
th {
  font-weight: bold !important;
}
tr,
td,
th {
  border: 1px solid black;
  /* text-align: center; */
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid black;
  border: 1px solid black;
  font-size: small;
}
td {
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  /* text-align: center; */
  font-size: small;
}

.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
@media print {
  /* Force landscape print */
  @page {
    size: A3 landscape;
    margin: 10mm;
  }

  /* Make Vuetify table behave like normal table in print */
  .v-simple-table, table {
    width: max-content !important;
    table-layout: auto !important;
    border-collapse: collapse !important;
  }

  /* Remove scroll wrapper and allow overflow */
  .table-data {
    height: auto !important;
    overflow: visible !important;
    display: block !important;
  }

  /* Ensure dynamic columns stay visible */
  #my-table-id1 {
    width: max-content !important;
    overflow: visible !important;
  }

  /* Prevent shrinking of columns */
  th, td {
    white-space: nowrap !important;
    font-size: 11px !important;
  }

  /* Hide buttons, filters, cards, etc. */
  .no-display,
  .v-btn,
  .v-input,
  .v-select,
  .v-autocomplete,
  .v-toolbar,
  .v-snackbar {
    display: none !important;
  }

  /* Ensure table prints, not Vue styling wrapper */
  .v-data-table {
    display: table !important;
  }
}
</style>
